/* global G */
import { pipe } from '@gaia/util'
import { hasNamespace } from '@gaia/trait/has'
import { usesNamespace } from '@gaia/trait/uses'
import { withObjectFreeze, withDescriptor } from 'trait/with'
import api from 'platform/adapter/persistence/api'

const descriptor = 'adapter:Persistence'

/**
 * Persistence Adapter.
 *
 * Adapter used to persist data locally.
 *
 * @memberOf Gaia.Adapter
 * @typedef {Function} Gaia.Adapter.Persistence
 * @property {Gaia.Adapter.Persistence.API} G.API
 */

/**
 * @returns {Gaia.Adapter.Persistence}
 */
const persistenceAdapter = () => pipe(
  withDescriptor(descriptor),
  hasNamespace(G.API),
  usesNamespace(G.API, api()),
  withObjectFreeze,
)({})

export default persistenceAdapter
